export default "__VITE_ASSET__CbjM9j0n__"